var React = require('react');

function SmallArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.75 8.25L9.25 11.75L10.25 10.75L7.75 8.25L10.25 5.75L9.25 4.75L5.75 8.25Z","fill":"#A5AEB6"}));
}

SmallArrow.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = SmallArrow;

SmallArrow.default = SmallArrow;
